<puro-modal
  class="review-payment-modal__modal"
  [className]="'review-payment-modal__modal'"
  [open]="open()"
  [title]="modalTitle()"
  size="large"
  [showCloseButton]="!processing()"
  [closeOnBackdrop]="false"
  (closeModal)="onClose()"
>
  @if (processing()) {
    <output class="review-payment-modal__processing" data-testid="payment-processing-status">
      <span class="review-payment-modal__spinner" aria-hidden="true"></span>
      <puro-typography component="p" variant="body1" class="review-payment-modal__processing-text">
        {{ 'createShipment.reviewAndPay.paymentModal.processing' | translate }}
      </puro-typography>
    </output>
  }
  <div
    [id]="hostId"
    class="review-payment-modal__host"
    data-testid="moneris-checkout-host"
    [hidden]="processing()"
    [attr.aria-label]="'createShipment.reviewAndPay.paymentModal.hostAria' | translate"
  ></div>
</puro-modal>
